export default __webpack_public_path__ + "static/media/audio-context-illustration.a87708d5.png";